import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { debounceTime, distinctUntilChanged, Subject, switchMap } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { deactivated } from 'src/app/Models/deactivated';
import { UserItem, UsersApiResponse, UsersResponseData, Vehicle, VehicleImage } from 'src/app/Models/Users';
import { ConfirmationServiceService } from 'src/app/Services/confirmation-service.service';
import { UsersService } from 'src/app/Services/users.service';
import { CustomToasterServiceService } from 'src/app/Services/custom-toaster-service.service';
import { guide } from 'src/app/Models/guide';
import { Booking, BookingCancellationReason, BookingDetailsOutput, CancellationDetails, ChatMessage } from 'src/app/Models/booking';
import { BookingComponent } from '../booking/booking.component';
import { BookingService } from 'src/app/Services/booking.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
})
export class UserComponent {

  touristicon: boolean = true
  allusersvar: boolean = true
  touristvar: boolean = false
  tourvar: boolean = false
  Activated: boolean = true
  applicationvar: boolean = true
  previewImageUrl: string = '';
allbookingarray:number[]=[]
BookingHistorytotalbookingpage = 0;
  pageSize = 10;
AdminUserId:number=0;
  toursection: boolean = true
  messagesection: boolean = false
  paymentsection: boolean = false
  totalUsers: number = 0
  totalPages: number = 0
  adminid: number = 0
  totalAll: number = 0
  userId = 0
  UserId: number | null = null;
  searchText: string = '';
  username: string = ''
  bookinghistory: boolean = false
  currentPage: number = 1;

  bookingHistoryTotalCount:number=0
 viewMode  = 'overview';
  BookingHistory:Booking[]|null=null;
GuideVehicle:Vehicle| null = null;
vehicleImages: VehicleImage[] = [];
  pages: number[] = [];

 guideVehicleViewMode: 'overview' | 'vehicleDetails' = 'overview';
 selectedGuideVehicle: Vehicle | null = null;
 guideVehicleImages: VehicleImage[] = [];
 guideVehicleIndex: number = 0;

 getVehicleImageUrl(vehicle: Vehicle | null | undefined, imageType?: string): string {
  if (!vehicle || !Array.isArray(vehicle.vehicleImages) || vehicle.vehicleImages.length === 0) {
    return '/assets/userIcon/car.svg';
  }

  if (imageType) {
    const typed = vehicle.vehicleImages.find(img => img.imageType === imageType);
    if (typed?.imageUrl) return typed.imageUrl;
  }

  const firstWithUrl = vehicle.vehicleImages.find(img => !!img.imageUrl);
  return firstWithUrl?.imageUrl || '/assets/userIcon/car.svg';
 }

 getVehicleImages(vehicle: Vehicle | null | undefined): VehicleImage[] {
  if (!vehicle || !Array.isArray(vehicle.vehicleImages)) return [];
  return vehicle.vehicleImages;
 }

pageSizeAll: number = 10;
pageSizeTourists: number = 10;
pageSizeGuides: number = 10;
pageSizeApproved: number = 10;
rejection:boolean=false
showtogle:boolean=false
rectionarray:any[]=[]
@ViewChild('closeBtn') closeBtn!: ElementRef;
@ViewChild('closeBtn2') closeBtn2!: ElementRef;

windowtouristSize: number = 5;searchSubject = new Subject<string>();
groupedReasons: { [key: string]: any[] } = {};


bookingcanceldetails: CancellationDetails = {
  sendToEmail: '',
  reciversName: '',
  touristName: '',
  tourGuideName: '',
  tourstartDate: '',
  tourEndDate: '',
  tourDestination: '',
  bookingId: 0,
  cancelledByRole: '',
  cancelledOn: '',
  cancellationReason: ''
};
roleid:number=0

 ngOnInit(): void {


    this.setupDebounceSearch();
    this.loadAllUsers();
   
    this.getguideAprove()
    // this.loadTourGuides();
this.getreasonofreject()

  
    const storedData = sessionStorage.getItem('userData');
    if (storedData) {
      const parsedData = JSON.parse(storedData);
  
      this.adminid = parsedData.userId;
      this.username = parsedData.firstName
    this.searchSubject.pipe(
    debounceTime(500), 
    distinctUntilChanged()
  ).subscribe(searchText => {
    debugger
    if(this.getuserid.roleId == 2)
      {  this.loadTouristBookingHistory(searchText);}
    else if(this.getuserid.roleId == 3){
      this.loadGuideBookingHistory(searchText)
    }

  
  });

  this.loadTouristBookingHistory();

    }



  }

 

  onrejection()
  {
    this.rejection=true
  }

backonform()
{
  if(this.rejection)
  {
  this.rejection=false
  }
}


getRemainingDays(endDate: string): number {
  const today = new Date();
  const end = new Date(endDate);
  const diff = end.getTime() - today.getTime();
  return Math.max(0, Math.ceil(diff / (1000 * 3600 * 24)));
}
selectedStatus: string[] = ['Pending', 'Confirmed', 'InProgress', 'Completed', 'Cancelled'];

selectedfilter: string = '';  
onStatusChange() {
  this.selectedStatus = this.selectedfilter ? [this.selectedfilter] : ['Pending', 'Confirmed', 'InProgress', 'Completed', 'Cancelled'];

  if (this.getuserid.roleId === 2) {
    this.loadTouristBookingHistory('');
  } else if (this.getuserid.roleId === 3) {
    this.loadGuideBookingHistory('');
  }
}

getStatusClass(status: string): string {
  switch (status.toLowerCase()) {
    case 'completed':
      return 'bookingstatus';
    case 'pending':
      return 'bookingstatuspending';
    case 'confirmed':
      return 'bookingstatusupcoming';
       case 'inprogress':
      return 'bookingstatusupcoming';
    case 'cancelled':
      return 'bookingstatuscanceled';
    default:
      return '';
  }
}

getStatusIcon(status: string): string {
  switch (status.toLowerCase()) {
    case 'completed':
      return 'assets/userIcon/CompletedIcon.svg';
    case 'pending':
      return '/assets/userIcon/pendingIcon.svg';
    case 'confirmed':
      return '/assets/userIcon/Upcomingicon.svg';
    case 'cancelled':
      return '/assets/userIcon/CancellIcon.svg';
    case 'inprogress':
      return '/assets/userIcon/inprogress.svg';  
    default:
      return '';
  }
}

getuserid: UserItem = {
  userId: 0,
  firstName: '',
  lastName: '',
  profilePhotoUrl: '',
  gender: '',
  roleId: 0,
  email: '',
  avgRating: 0,
  createdAt: '',
  isDeactivate: false,
  displayName: '', 
  tourGuideUserId: 0,
  tourGuideId: 0,
  imageUrl: '',
  vehicles: [],
  languages: [],
  dialCode: '',
  phoneNumber: '',
  country: '',
  countryCode: ''


};

    
 getguide: Partial<guide> = {};



  private searchAll$ = new Subject<string>();
  private searchTourists$ = new Subject<string>();
  private searchGuides$ = new Subject<string>();
  private searchverifyGuides$ = new Subject<string>();


  currentPages: number = 1;
  minPage: number = 1;
  maxPage: number = 4;

BookingHistorypageNumber:number=1
  allUsers: any[] = [];
  tourists: any[] = [];
  tourGuides: any[] = [];
  guideapprove: guide[] = []
activeTab: string = 'tour'; // default

  totalguidepage = 0
  pageAll = 1;
  pageTourists = 1;
  pageGuides = 1;

  totalTourists = 0
  totalPagesTourists = 0
originalUserData: UserItem | null = null;
  totalguide = 0
  totalGuides = 0
  searchAll = '';
  searchTourists = '';
  searchGuides = '';
BookinghistorypageSize:number=10;
  searchguidetext: string = ''
  guidepage: number = 1
  guidepagesize: number = 10

  docnum: number = 1

  totalaprove: number = 0
 documentImages: { url: string; label: string }[] = [];

  private searchTextSubject = new Subject<string>();
  deactivated: Partial<deactivated> = {};
  guideuser: any = {};

  touristcollections: string[] = []
  guidecollections: string[] = []
  touristpages: number[] = []


  aproveuser: number[] = []
  totalaprovepage: number = 0
  totalaproveuser: number = 0

  constructor(

    private userservice: UsersService,
    private confirmDialogService: ConfirmationServiceService,
    private toasterService: CustomToasterServiceService,
    private bookingservice:BookingService


  ){ }

  openPhotoPreview(url?: string | null) {
    this.previewImageUrl = url || 'assets/userIcon/user.png';
  }
  
  
  closeCanvas(){
    this.viewMode='overview'
  }
  
  userlength:number=0

getuserarr:UserItem[]=[]
 jumpPageInput: number = 1; 
 jumpPageInputt: number = 1;   
 jumpPageInputg: number = 1;   
selectedTab: string = 'all'; // default
applicationtab:boolean=false

selectTab(tab: string) {
  this.selectedTab = tab;
  this.pageAll = 1; 
  if (tab === 'all') {
    this.roleid = 0;
    this.loadAllUsers();
  } else if (tab === 'tourist') {
    this.roleid = 2;
    this.loadAllUsers();
  } else if (tab === 'tour') {
    this.roleid = 3;
    this.loadAllUsers();
  } else if (tab === 'Application') {
    this.getguideAprove();
  }
}
  selectguideTabs: string = 'overview'; 
  selectguideTab(tab: string) {
    this.selectguideTabs = tab;

  
    if (tab === 'overview') {

    } else if (tab === 'verifaication') {

    }

  }








 

  next() {
    if (this.docnum < 3) {
      this.docnum++
    }

  }

  previous() {
    if (this.docnum > 1) {
      this.docnum--
    }

  }


  onSearch(type: 'all' | 'tourists' | 'guides' | 'verifyguide', value: string) {
    if (type === 'all') this.searchAll$.next(value);
    if (type === 'tourists') this.searchTourists$.next(value);
    if (type === 'guides') this.searchGuides$.next(value);
    if (type === 'verifyguide') this.searchverifyGuides$.next(value);
  }

  selectedTabs: string = 'overview'; 

  setupDebounceSearch() {
    this.searchAll$.pipe(debounceTime(1000)).subscribe(value => {
      this.searchAll = value;
      this.pageAll = 1;
      this.loadAllUsers();
    });

    this.searchTourists$.pipe(debounceTime(500)).subscribe(value => {
      this.searchTourists = value;
      this.pageTourists = 1;
     
    });

    this.searchGuides$.pipe(debounceTime(500)).subscribe(value => {
      this.searchGuides = value;
      this.pageGuides = 1;
      // this.loadTourGuides();
    });
    this.searchverifyGuides$.pipe(debounceTime(500)).subscribe(value => {
      this.searchguidetext = value;
      this.pageGuides = 1;
      this.getguideAprove();
    })
  }




onSearchInput(event: Event): void {
  const input = event.target as HTMLInputElement;
  this.searchSubject.next(input.value);
}





goToPages(pageNumber: number): void {
  debugger
  if (pageNumber >= 1 && pageNumber <= this.BookingHistorytotalbookingpage) {
    this.BookingHistorypageNumber = pageNumber;

      if(this.getuserid.roleId==2){
    this.loadTouristBookingHistory()
  }
  else  if(this.getuserid.roleId==3){
    this.loadGuideBookingHistory()
  }

   
}}




  gettouristvar() {
    this.allusersvar = false
    this.touristvar = true
    this.tourvar = false
  }

  gettour() {
    this.allusersvar = false,
      this.touristvar = false,
      this.tourvar = true
  }

  alluser() {
    this.allusersvar = true
    this.touristvar = false
    this.tourvar = false
  }


  messageturns() {
    this.toursection = false
    this.paymentsection = false
    this.messagesection = true
  }
  tourturns() {
    this.toursection = true
    this.paymentsection = false
    this.messagesection = false
  }
  paymentturns() {
    this.toursection = false
    this.paymentsection = true
    this.messagesection = false
  }


  filterrecord() {
    this.Activated = !this.Activated
  }


openUserProfile(user: UserItem) {
  debugger
  this.getuserid = JSON.parse(JSON.stringify(user));         
  this.originalUserData = JSON.parse(JSON.stringify(user));  

  this.viewMode = 'overview';
  this.GuideVehicle=null;
}
resetAllFields() {
  this.getuserid = JSON.parse(JSON.stringify(this.originalUserData)); 
  this.editFields = {};  
  this.Togleswitch();
}

  openGuideProfile(guide: guide) {
    debugger
    this.guideuser = { ...guide };
    this.buildImageList();
    this. selectguideTabs = 'overview'; 
    this.guideVehicleViewMode = 'overview';
    this.selectedGuideVehicle = this.guideuser?.vehicles ? (this.guideuser.vehicles[0] || null) : null;
    this.guideVehicleImages = this.selectedGuideVehicle ? (this.selectedGuideVehicle.vehicleImages || []) : [];
    this.guideVehicleIndex = 0;
   
  }

 toggleGuideVehicleView(view: 'overview' | 'vehicleDetails') {
  this.guideVehicleViewMode = view;
  this.selectedGuideVehicle = this.guideuser?.vehicles ? (this.guideuser.vehicles[0] || null) : null;
  this.guideVehicleImages = this.selectedGuideVehicle ? (this.selectedGuideVehicle.vehicleImages || []) : [];
  this.guideVehicleIndex = 0;
 }

 guidePreviousVehicleImage(): void {
  if (this.guideVehicleIndex > 0) {
    this.guideVehicleIndex--;
  }
 }

 guideNextVehicleImage(): void {
  if (this.guideVehicleIndex < this.guideVehicleImages.length - 1) {
    this.guideVehicleIndex++;
  }
 }

  buildImageList() {
    debugger
    const sources = [
      { key: 'tourGuideGovIdUrl', label: 'National ID' },
      { key: 'licenceImgUrl', label: 'Licence' },

    ];

    this.documentImages = sources
      .filter(doc => !!this.guideuser[doc.key])
      .map(doc => ({
        url: this.guideuser[doc.key],
        label: doc.label
      }));

   
    if (this.documentImages.length === 0 ) {
      this.documentImages.push({
        url: '/assets/userIcon/doc.png',
        label: 'No Document Available'
      });
    }
 


  }

  toggleView(view: 'overview' | 'history' | 'payout'|'vehicleDetails') {
    this.viewMode = view;
debugger
    if (view == 'history') {
      if(this.getuserid.roleId==2){
        this.loadTouristBookingHistory()
      }
      else if(this.getuserid.roleId==3){
        this.loadGuideBookingHistory()

      }
    }
    if (view == 'payout'|| view == 'vehicleDetails') {
      this.GuideVehicle= this.getuserid.vehicles ? this.getuserid.vehicles[0] || null : null;
      this.vehicleImages = this.GuideVehicle ? this.GuideVehicle.vehicleImages : [];
  }

  }
getFrontImageUrl(): string {
  const frontImage = this.vehicleImages.find(img => img.imageType === 'Front');
  return frontImage ? frontImage.imageUrl : '/assets/userIcon/car.svg'; 
}
   previousImage(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  nextImage(): void {
    if (this.currentIndex < this.vehicleImages.length - 1) {
      this.currentIndex++;
    }}
currentIndex: number = 0;

showNext() {
  if (this.documentImages.length === 0) return;
  this.currentIndex = (this.currentIndex + 1) % this.documentImages.length;
}

showPrevious() {
  if (this.documentImages.length === 0) return;
  this.currentIndex =
    (this.currentIndex - 1 + this.documentImages.length) % this.documentImages.length;
}
loadTouristBookingHistory(searchText: string = '') {
  debugger;

  if (this.getuserid.userId > 0) {
 
    const bookingStatuses: string[] = Array.isArray(this.selectedStatus)
      ? this.selectedStatus
      : this.selectedStatus ? [this.selectedStatus] : [];

    this.userservice.getTouristBookingHistory(
      this.getuserid.userId,
      this.BookingHistorypageNumber,
      this.BookinghistorypageSize,
      searchText,
      bookingStatuses
    ).subscribe((res) => {
      this.BookingHistory = res.items;
      this.bookingHistoryTotalCount = res.totalCount;
      this.BookingHistorytotalbookingpage = Math.ceil(this.bookingHistoryTotalCount / this.BookinghistorypageSize);
      this.allbookingarray = Array.from({ length: this.bookingHistoryTotalCount }, (_, i) => i + 1);
    });
  } else {
    return;
  }
}

loadGuideBookingHistory(searchText: string = '') {
  if (this.getuserid.userId > 0) {
    const tourGuideUserId = this.getuserid.userId;

  
    const bookingStatuses: string[] = Array.isArray(this.selectedStatus)
      ? this.selectedStatus
      : this.selectedStatus ? [this.selectedStatus] : [];

    this.userservice.getGuideBookingHistory(
      tourGuideUserId,
      this.BookingHistorypageNumber,
      this.BookinghistorypageSize,
      searchText,
      bookingStatuses
    ).subscribe((res) => {
      this.BookingHistory = res.items;
      this.bookingHistoryTotalCount = res.totalCount;
      this.BookingHistorytotalbookingpage = Math.ceil(this.bookingHistoryTotalCount / this.BookinghistorypageSize);
      this.allbookingarray = Array.from({ length: this.BookingHistorytotalbookingpage }, (_, i) => i + 1);
    });
  } else {
    return;
  }

  debugger;
}



  guidepages: number[] = []







ApproveGuideReq() {
  this.confirmDialogService.openConfirmDialog('You are about to reactivate this tour guide’s account. Once activated, the guide will regain full access to all platform features including login, booking management, and earnings dashboard.', () => {
    this.userservice.ApproveTouGuideReq(this.guideuser.tourGuideId, this.adminid).subscribe((res) => {
      this.toasterService.success("Tour Guide Approved Successfully");
      this.sendWelcomeEmail();
      this.getguideAprove()
     this.closeBtn.nativeElement.click();
    });
  },'/assets/userIcon/Active.png');
}

sendWelcomeEmail() {

  this.userservice.SendWelcomeEmail(this.guideuser.email, this.guideuser.firstName, this.guideuser.tourGuideId).subscribe((res) => {
    
    this.toasterService.success("Welcome Email Sent Successfully");
  }, (error) => {
   
    this.toasterService.error("Failed to send welcome email");
  });
}


goToallPage(pageNumber: number | string): void {
  
  if (typeof pageNumber !== 'number') return;

  if (pageNumber >= 1 && pageNumber <= this.totalPages) {
    this.pageAll = pageNumber;
    this.loadAllUsers();
    
  }
}



  onSizeChanges(newSize: number): void {
    this.pageSize = newSize;
    this.pageAll = 1;
    this.loadAllUsers();
  }



goToPage(pageNumber: number): void {
    
  if (typeof pageNumber !== 'number') return;
  if (pageNumber >= 1 && pageNumber <= this.totalPagesTourists) {
    this.pageTourists = pageNumber;
  
  }
}


  touristonSizeChanges(newSize: number): void {
    this.pageSizeTourists = newSize;
    this.pageTourists = 1;
  
  }



    goToHistoryPages(pageNumber: number): void {
      debugger
    if (pageNumber >= 1 && pageNumber <= this.BookingHistorytotalbookingpage) {
      this.BookingHistorypageNumber = pageNumber;
 if (this.getuserid.roleId === 2) {
    this.loadTouristBookingHistory('');
  } else if (this.getuserid.roleId === 3) {
    this.loadGuideBookingHistory('');
  }
    }
  }

  onHistorySizeChanges(newSize: number): void {
    debugger
    this.BookinghistorypageSize = newSize;
    this.BookingHistorypageNumber = 1;
  if (this.getuserid.roleId === 2) {
    this.loadTouristBookingHistory('');
  } else if (this.getuserid.roleId === 3) {
    this.loadGuideBookingHistory('');
  }
  }


approvegoToPage(pageNumber: number): void {
  if (typeof pageNumber !== 'number') return;
  if (pageNumber >= 1 && pageNumber <= this.totalaprovepage) {
    this.guidepage = pageNumber;
    this.getguideAprove();
  }
}

aproveonSizeChanges(newSize: number): void {
  this.pageSizeApproved = newSize;
  this.guidepage = 1;
  this.getguideAprove();
}




 getguideAprove(): void {
  this.userservice.gettourguide(this.searchguidetext, this.guidepage, this.pageSizeApproved).subscribe((res) => {
    this.guideapprove = res.data.items;
    this.totalaproveuser = res.data.totalCount;
    this.totalaprovepage = Math.ceil(this.totalaproveuser / this.pageSize);
    this.aproveuser = Array.from({ length: this.totalaprovepage }, (_, i) => i + 1);

   
  });
}



  Deactivateduser(userId: number) {
    this.confirmDialogService.openConfirmDialog('You are about to deactivate this tour guide’s account. Once deactivated, the guide will not be able to log in, accept bookings, or access any platform features.?', () => {
      this.userservice.DeactivatedUser(userId, this.adminid).subscribe((res) => {
      
        this.toasterService.success("User Deactivated Successfully");
        this.loadAllUsers();
        
      
      });
    }, '/assets/userIcon/deactivate.png'
  );
  }




  jumpToPage(): void {
    if (this.jumpPageInput >= 1 && this.jumpPageInput <= this.totalPages) {
      this.pageAll = this.jumpPageInput;
      this.loadAllUsers();
    } else {
      alert(`Enter a page number between 1 and ${this.totalPages}`);
    }
  }




uniqueSections: string[] = [];
checkid:number=0;
othermsg:string=''
resonvar:string=''
getchekid(checkId:number,reson:string)
{
  this.checkid=checkId
  this.resonvar=reson
}

getreasonofreject()
{
  this.userservice.getreasonforreject().subscribe((res)=>{

this.rectionarray=res
  this.uniqueSections = Array.from(new Set(this.rectionarray.map(r => r.sectionName)));


  })
}
rejectapplication()
{
  debugger
  this.confirmDialogService.openConfirmDialog('Are you sure you want to reject this application?This will notify the applicant by email with the selected reason. The applicant must log in and resubmit the application after correcting the issues mentioned in the email.'                              , () => {
    if(this.checkid==0 || this.resonvar==''){
      this.toasterService.error("Please Select Reason")
      return;
    }
    this.userservice.rejectbookingbyadmin(this.guideuser.tourGuideId,this.checkid,this.adminid,this.othermsg).subscribe((res)=>{
this.rejectmail()
this.getguideAprove()
   this.toasterService.success("Tour Guide Request Rejected Successfully");
   this.checkid=0
   this.resonvar=''

  })
},'/assets/userIcon/rejectapp.png')}

rejectmail()
{
  debugger
  this.userservice.sendrejectmail(this.guideuser.email,this.guideuser.firstName,this.resonvar,this.othermsg ).subscribe((res)=>{

 this.closeBtn.nativeElement.click();
  
  })
}






 chatHistory: ChatMessage[] = [];
  SelectededtouristUserId: number | null = null

  selectedBooking: Booking | null = null;

  SelectedtourGuideUserId: number | null = null


getresonofcancel:BookingCancellationReason[]=[]





getRemainingDayss(endDate: string): number {
  const today = new Date();
  const end = new Date(endDate);
  const diff = end.getTime() - today.getTime();
  return Math.max(0, Math.ceil(diff / (1000 * 3600 * 24)));
}






 messageturnss(selectedBooking: Booking | null) {
    debugger
 
    if (selectedBooking) {
      
      this.SelectededtouristUserId = selectedBooking.userId;
      this.SelectedtourGuideUserId = selectedBooking.tourGuideUserId;


      this.getChatHistory(this.SelectededtouristUserId, this.SelectedtourGuideUserId)
    }
    else {
      this.toasterService.error("Not Selected Booking Properly")
    }
    this.toursection = false
    this.paymentsection = false
    this.messagesection = true
  }



  SetSelectedBooking(item: Booking) {
    this.selectedBooking = {...item}

  }

  closeBookingOffCanava() {
    debugger
    this.selectedBooking = null
    this.reasonvisiable=false
  }

  getChatHistory(user1Id: number, user2Id: number) {
    this.bookingservice.getAllChatHistory(user1Id, user2Id).subscribe((res) => {
      this.chatHistory = res
    
    })
  }




occancelbooking()
{
  this.userservice.getreasonforbooking().subscribe((res)=>{

this.getresonofcancel=res


  })
}
reasonvisiable:boolean=false
reasoncancelgo()
{
this.reasonvisiable=true
this.occancelbooking()
}

reasonid:number=0
optionalreson:string=''

stringreason:string=''
getreasonid(reasonId:number,reasonstring:string)
{
this.reasonid=reasonId
this.stringreason=reasonstring
}

cancelbooking()
{debugger
    this.confirmDialogService.openConfirmDialog('Are you sure you want to cancel this booking? This action will notify the tourist and the guide. Please select a reason to help us improve our services.', () => {
 if (
  typeof this.UserId !== 'number' ||
  typeof this.selectedBooking?.bookingId !== 'number' ||
  typeof this.reasonid !== 'number'
) {
  return;

}
  
  this.userservice.cancelbookingbyadmin(this.selectedBooking?.bookingId,this.UserId,this.reasonid,this.optionalreson).subscribe((res)=>{

 this.toasterService.success("Cancel Booking successfully");
 
  
  })
},'/assets/confirmation-msg/frame.png')


}

sendcancelmailtotourist()

{
  debugger
   if (this.selectedBooking?.bookingId === undefined ) {
   
    return;
  }
  this.bookingcanceldetails.bookingId=this.selectedBooking?.bookingId
  this.bookingcanceldetails.cancelledByRole="Admin"
   this.bookingcanceldetails.reciversName=this.selectedBooking?.touristName
   this.bookingcanceldetails.sendToEmail=this.selectedBooking?.touristEmail
    this.bookingcanceldetails.touristName=this.selectedBooking?.touristName
     this.bookingcanceldetails.tourEndDate=this.selectedBooking?.tourEndDate
      this.bookingcanceldetails.tourstartDate=this.selectedBooking?.tourStartDate
       this.bookingcanceldetails.cancellationReason=this.stringreason
        this.bookingcanceldetails.cancelledOn=new Date().toISOString();
         this.bookingcanceldetails.tourGuideName=this.selectedBooking?.guideName
          this.bookingcanceldetails.tourDestination=this.selectedBooking?.tourLocation
  this.userservice.sendtomailoncancel(this.bookingcanceldetails).subscribe((res)=>{




  })
}



sendcancelmailtotourguide()

{
  debugger
   if (this.selectedBooking?.bookingId === undefined ) {
   
    return;
  }
  this.bookingcanceldetails.bookingId=this.selectedBooking?.bookingId
  this.bookingcanceldetails.cancelledByRole="Admin"
   this.bookingcanceldetails.reciversName=this.selectedBooking?.touristName
   this.bookingcanceldetails.sendToEmail=this.selectedBooking?.tourGuideEmail
    this.bookingcanceldetails.touristName=this.selectedBooking?.touristName
     this.bookingcanceldetails.tourEndDate=this.selectedBooking?.tourEndDate
      this.bookingcanceldetails.tourstartDate=this.selectedBooking?.tourStartDate
       this.bookingcanceldetails.cancellationReason=this.stringreason
        this.bookingcanceldetails.cancelledOn=new Date().toISOString();
         this.bookingcanceldetails.tourGuideName=this.selectedBooking?.guideName
          this.bookingcanceldetails.tourDestination=this.selectedBooking?.tourLocation
  this.userservice.sendtomailoncancel(this.bookingcanceldetails).subscribe((res)=>{




  })
}



  loadAllUsers() {
    debugger
    this.userservice.getAllUsers(this.searchAll, this.pageAll, this.pageSize,this.roleid)
      .subscribe((res: UsersApiResponse) => {
        this.getuserarr = res.data.items;

        this.totalAll = res.data.totalCount;
        
      this.totalPages = Math.ceil(this.totalAll / this.pageSize);
    
         this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
         
      });
  }

originalValues: { [key: string]: any } = {};
editFields: { [key: string]: boolean } = {
  firstName: false,
  lastName: false,
  email: false
  // Add more keys if needed
};

toggleInput(field: string): void {
  this.editFields[field] = !this.editFields[field];
}

Togleswitch(): void {
  // Simply turn off all edit flags to hide all input fields
  for (let key in this.editFields) {
    this.editFields[key] = false;
  }
}

EditNameFun()
{debugger

  if(this.getuserid.firstName.trim() === '' || this.getuserid.lastName.trim() === '') {
    this.toasterService.error("First Name and Last Name cannot be empty");
    return;
  }
  this.userservice.Updatename(this.getuserid.firstName,this.getuserid.lastName,this.getuserid.userId).subscribe((res)=>{

this.toasterService.success("User Updated successfully");
this.getuserid
this.loadAllUsers()
this.Togleswitch()
 this.closeBtn2.nativeElement.click();
  })
}
 
}
